import React from "react";
import CurrentDate from "./CurrentDate.js";
import WeatherIcon from "./WeatherIcon.js";
import "./Weather.css";
import WeatherTemp from "./WeatherTemp.js";
import WeatherForecast from "./WeatherForecast.js";

export default function WeatherInfo(props) {
  return (
    <div>
      <div className="small">
        <div className="row">
          <div className="left col-4">
            <h1>{props.data.city}</h1>
            <ul>
              <li>
                <CurrentDate date={props.data.date} />
              </li>
              <li className="text-capitalize">{props.data.description}</li>
              <li>
                {" "}
                <WeatherTemp celsius={props.data.temperature} />
              </li>
            </ul>
          </div>
          <div className="middle col-4">
            <WeatherIcon
              code={props.data.icon}
              size={90}
              alt={props.data.description}
            />
            <div className="vl"></div>
          </div>
          <div className="right col-4">
            <ul>
              <li>Humidity: {props.data.humidity}%</li>
              <li>Wind: {Math.round(props.data.wind)}km/h</li>
              <li>Clouds: {props.data.clouds}%</li>
            </ul>
          </div>
        </div>
      </div>
      <WeatherForecast coord={props.data.coord} />

      <div className="hl"></div>
      <footer>
        <a
          href="https://github.com/InesKachanova/Weather-App"
          target="_blank"
          rel="noreferrer"
        >
          Open-source code
        </a>
        , by Inessa Kachanova
      </footer>
    </div>
  );
}
